import { analyticsService } from "./analytics";
import { createClient, createUser, createUserUpdate, omitUndefined } from "./firebase";
import type { Result, User } from "../shared/types";

export async function createBooker(
    booker: User,
    authenticatedUser?: User,
): Promise<Result & { clientId?: string }> {
    let clientId = booker.clientId;

    if (!clientId) {
        const clientRes = await createClient({
            name: booker.company!,
            primaryBookerEmail: booker.email || "",
            primaryBookerId: booker.id || "",
            primaryManagerId: authenticatedUser?.id || "",
            airtablePrimaryManagerId: authenticatedUser?.managerAirtableId || "",
        });

        if (clientRes.success) {
            clientId = clientRes.result;
        }
    }

    const res = await createUser(createUserUpdate(omitUndefined({
        firstName: booker.firstName,
        lastName: booker.lastName,
        email: booker.email,
        company: booker.company,
        campaignType: booker.campaignType,
        clientId,
        verified: true,
        roles: { booker: true },
    })));

    analyticsService().logEvent("Created Booker", {
        ...booker,
        clientId,
    });

    // `createUser` hands back only the new uid, so surface the resolved clientId as well: it's
    // written to the user doc, but the caller's local booker object would never otherwise learn it
    // and any booking built from it would be created without a clientId.
    return { ...res, clientId };
}
